import { Component } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'app-loading',
  templateUrl: 'component.html',
  styleUrls: ['component.scss']
})
export class LoadingComponent {}
